var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"resume",attrs:{"id":"resume"}},[_c('router-link',{attrs:{"to":"/resume"}},[_c('h2',{class:this.$vuetify.theme.dark
          ? 'section__title section__title--resume dark-section__title--resume'
          : 'section__title section__title--resume'},[_c('i',{staticClass:"far fa-file"}),_vm._v(" My Résumé ")]),_c('p',{class:this.$vuetify.theme.dark
          ? 'section__subtitle section__subtitle--resume dark-section__subtitle--resume'
          : 'section__subtitle section__subtitle--resume'},[_c('strong',[_vm._v("click me")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }